<template>
  <b-card
    id="tooltip-node"
    style="
      width: 550px;
      opacity: 0;
      position: absolute;
      left: 150px;
      top: 150px;
      z-index: -1;
    "
    class="mb-2 shadow bg-white"
  >
    <b-card-title>
      <b-button id="tooltip-node-button-close" class="close">
        <span class="d-inline-block">&times;</span>
      </b-button>
      <h4>
        {{ node.name }}
        <span
          class="badge badge-secondary"
          :style="{
            'background-color': entityColorScale(node.group),
          }"
        >
          {{ node.group }}
        </span>
      </h4>
    </b-card-title>
    <b-card-text>
      Occurrences: {{ node.value }}
      <b-button
        variant="outline-primary"
        size="sm"
        class="mx-2"
        @click="showAllDocuments()"
        >Show all Documents</b-button
      >
      <hr />
      <b-overlay
        :show="status.showSpinner"
        rounded="sm"
        style="overflow-y: auto; min-height: 250px; max-height: 400px"
      >
        <b-card
          v-for="(sentence, id) in sentences"
          :key="id"
          title=""
          class="m-2"
          no-body
        >
          <b-card-body>
            <b-card-text>
              <span v-for="(token, id) in sentence" :key="id">
                <span
                  v-if="
                    token.entity_type === node.group &&
                    token.text.toLowerCase() === node.name.toLowerCase()
                  "
                >
                  <mark>{{ token.text }}</mark>
                  <span> </span>
                </span>
                <span v-else class="text-muted">{{ token.text }} </span>
              </span>
            </b-card-text>
          </b-card-body>

          <b-card-footer
            ><span class="text-muted">{{
              "Document: " + sentence[0].d_id
            }}</span>
            <b-link
              variant="primary"
              size="sm"
              class="float-right"
              @click="showDocument(sentence[0].d_id)"
              >Show Document</b-link
            >
          </b-card-footer>
        </b-card>
      </b-overlay>
    </b-card-text>
  </b-card>
</template>

<script>
import requestsMixin from "../mixins/requestsMixin";
import constantsMixin from "../mixins/constantsMixin";

export default {
  name: "component-tooltip-node",
  mixins: [requestsMixin, constantsMixin],
  props: {
    corpus_id: { type: String },
    node: { type: Object },
  },
  data() {
    return {
      status: {
        showSpinner: true,
      },
      sentences: [],
    };
  },
  methods: {
    showDocument(documentId) {
      this.$emit("documents_selected", [documentId]);
    },
    showAllDocuments() {
      this.$emit("documents_selected", this.documentIds);
    },
  },
  computed: {
    documentIds: function () {
      let ids = [];
      for (let key in this.sentences) {
        ids.push(this.sentences[key][0].d_id);
      }
      return ids;
    },
  },
  watch: {
    node() {
      this.fetchNodeDetails();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/exploreGraphTooltipNode.vue